import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import constants from 'constants';

const {
  EXPORT_USERS_CSV
} = constants;

function Tools({
                 count,
                 deleteUsers
               }) {
  return (
    <div className="admin_list">
      <div className="admin_list_users">
        <h5>Users (<span>{count}</span>)</h5>
      </div>
      <div className="admin_list_button">
      <Link className="button_classic" to="/users/new">
        <i class="material-icons"></i>
        Add user
      </Link>
        {/*<Link className="button_classic" to="/users/novo-nordisk">*/}
        {/*  <i class="material-icons"></i>*/}
        {/*  Novo Nordisk users*/}
        {/*</Link>*/}
        <Link className="button_classic" to="/users/approve">
          <i class="material-icons"></i>
          Approve Users Types
        </Link>
        <Link className="button_classic" to="/users/approve-ipna">
          <i class="material-icons"></i>
          Approve Users IGPNEA
        </Link>
        <a className="button_classic" href={EXPORT_USERS_CSV} target="_blank">
          Export user details
        </a>
      </div>
      <a className="button_delete" onClick={deleteUsers} href="#">Delete</a>

    </div>

  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/User/Toolbar/Tools.jsx